import React, { FC, useState } from 'react'

import {
	ExhibitionManagementModelState,
	RoomManagementModelState,
} from '@/models/connect'
import {
	ExhibitionCalendarInventorySaveParamsType,
	ExhibitionCalendarPriceSaveParamsType,
} from '@/services/exhibition'
import { PriceType } from '@/services/homestayManagement'
import { getDatesInRange } from '@/utils/utils'
import { EventSourceInput } from '@fullcalendar/core'
import cnLocale from '@fullcalendar/core/locales/zh-cn'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction' // nee
import FullCalendar from '@fullcalendar/react'
import { Button, InputNumber, Modal, message } from 'antd'
import { Dispatch, connect } from 'umi'
import ss from './index.less'

export enum MyCalendarMode {
	Price = 'price', // 价格模式
	Stock = 'stock', // 库存模式
	Other = 'other', // 其他模式
	RoomPrice = 'roomPrice', // 房间价格模式
}

interface MyCalendarProps {
	exhibitionId: string | number // 展览id or 房间id
	dispatch: Dispatch
	exhibitionManagement: ExhibitionManagementModelState
	roomManagement: RoomManagementModelState
	mode: MyCalendarMode // 日历模式
	onDismiss: () => void
	onSetPriceSuccess?: (value: string) => void
	onSetStockSuccess?: () => void
	events: EventSourceInput | undefined
}

const MyCalendar: FC<MyCalendarProps> = ({
	exhibitionId,
	dispatch,
	mode,
	onDismiss,
	onSetPriceSuccess,
	onSetStockSuccess,
	events,
}) => {
	const [showSetPriceModal, setShowSetPriceModal] = useState<boolean>(false) // 显示设置价格模态框
	const [showSetStockModal, setShowSetStockModal] = useState<boolean>(false) // 显示设置库存模态框
	const [showSetRoomPriceModal, setShowSetRoomPriceModal] = useState<boolean>(
		false,
	) // 显示设置房间价格模态框
	const [contextMenuInfo, setContextMenuInfo] = useState<any>(null)
	const [priceSetting, setPriceSetting] = useState<
		ExhibitionCalendarPriceSaveParamsType
	>({
		dateList: [],
		exhibitId: exhibitionId,
		sessionOnePrice: '',
		sessionTwoPrice: '',
		sessionThreePrice: '',
	}) // 价格设置
	const [stockSetting, setStockSetting] = useState<
		ExhibitionCalendarInventorySaveParamsType
	>({
		dateList: [],
		exhibitId: exhibitionId,
		sessionOneInventory: '',
		sessionTwoInventory: '',
		sessionThreeInventory: '',
	}) // 库存设置
	const [roomPriceSetting, setRoomPriceSetting] = useState<PriceType>({
		time: [],
		roomId: exhibitionId,
		price: '',
	}) // 房间价格设置

	/* 点击日历事件 */
	const handleEventClick = clickInfo => {
		clickInfo.jsEvent.preventDefault() // Preventing default right click action
		setContextMenuInfo({
			type: 'event',
			event: clickInfo.event,
			x: clickInfo.jsEvent.pageX,
			y: clickInfo.jsEvent.pageY,
		})
		if (mode === MyCalendarMode.Price) {
			setPriceSetting({
				...priceSetting,
				dateList: [clickInfo.event.startStr],
				sessionOnePrice: clickInfo.event._def.extendedProps?.priceOne,
				sessionTwoPrice: clickInfo.event._def.extendedProps?.priceTwo,
				sessionThreePrice: clickInfo.event._def.extendedProps?.priceThree,
			})
			setShowSetPriceModal(true)
		}
		if (mode === MyCalendarMode.RoomPrice) {
			console.log('clickInfo.event is :', clickInfo.event)
			setRoomPriceSetting({
				...roomPriceSetting,
				time: [clickInfo.event.startStr],
				price: clickInfo.event._def.extendedProps?.price,
			})
		} else {
			setStockSetting({
				...stockSetting,
				dateList: [clickInfo.event.startStr],
				sessionOneInventory: clickInfo.event._def.extendedProps?.inventoryOne,
				sessionTwoInventory: clickInfo.event._def.extendedProps?.inventoryTwo,
				sessionThreeInventory:
					clickInfo.event._def.extendedProps?.inventoryThree,
			})
			setShowSetStockModal(true)
		}
	}

	const handleDayClick = clickInfo => {
		clickInfo.jsEvent.preventDefault() // Preventing default right click action
		setContextMenuInfo({
			type: 'day',
			date: clickInfo.date,
			x: clickInfo.jsEvent.pageX,
			y: clickInfo.jsEvent.pageY,
		})
	}

	// const handleDateClick = arg => {
	// 	console.log('====================================')
	// 	console.log('arg is :', arg)
	// 	console.log('====================================')
	// 	alert(arg.dateStr)
	// }

	const onSelect = arg => {
		console.log('====================================')
		console.log('arg is :', arg)
		console.log('====================================')
		const dataRangeArr = getDatesInRange(arg.startStr, arg.endStr)
		console.log('selected ' + arg.startStr + ' to ' + arg.endStr, dataRangeArr)
		if (mode === MyCalendarMode.Price) {
			setPriceSetting({
				...priceSetting,
				dateList: dataRangeArr,
			})
			setShowSetPriceModal(true)
		} else if (mode === MyCalendarMode.RoomPrice) {
			setRoomPriceSetting({
				...roomPriceSetting,
				time: dataRangeArr,
			})
			setShowSetRoomPriceModal(true)
		} else {
			setStockSetting({
				...stockSetting,
				dateList: dataRangeArr,
			})
			setShowSetStockModal(true)
		}
	}

	/* 确定房间价格设置提交给后台 */
	const handleRoomPriceOk = () => {
		dispatch({
			type: 'roomManagement/saveRoomCalendarPrice',
			payload: roomPriceSetting,
			callback: res => {
				message.success('设置成功')
				onSetPriceSuccess!(res?.value)
				setShowSetRoomPriceModal(false)
				setRoomPriceSetting({
					...roomPriceSetting,
					price: '',
				})
			},
		})
	}
	/* 确定价格设置提交给后台 */
	const handlePriceOk = () => {
		dispatch({
			type: 'exhibitionManagement/saveExhibitionCalendarPrice',
			payload: priceSetting,
			callback: res => {
				message.success('设置成功')
				onSetPriceSuccess!(res?.value)
				setShowSetPriceModal(false)
				setPriceSetting({
					...priceSetting,
					sessionOnePrice: '',
					sessionTwoPrice: '',
					sessionThreePrice: '',
				})
				// TODO 回显日历刷新-价格
			},
		})
	}

	/* 确定库存设置提交给后台 */
	const handleStockOk = () => {
		dispatch({
			type: 'exhibitionManagement/saveExhibitionCalendarInventory',
			payload: stockSetting,
			callback: res => {
				message.success('设置成功')
				onSetStockSuccess!()
				setShowSetStockModal(false)
				setStockSetting({
					...stockSetting,
					sessionOneInventory: '',
					sessionTwoInventory: '',
					sessionThreeInventory: '',
				})
				// TODO 回显日历刷新-库存
			},
		})
	}

	/* 价格设置模态框取消 */
	const handlePriceCancel = () => {
		setShowSetPriceModal(false)
	}
	/* 房间价格设置模态框取消 */
	const handleRoomPriceCancel = () => {
		setShowSetRoomPriceModal(false)
	}

	/* 库存设置模态框取消 */
	const handleStockCancel = () => {
		setShowSetStockModal(false)
	}

	/* 根据类型过滤展示events */
	const filterEvents = (events: any) => {
		if (mode === MyCalendarMode.RoomPrice) {
			return events?.filter(event => {
				return event.title.includes('价格')
			})
		} else if (mode === MyCalendarMode.Price) {
			return events?.filter(event => {
				return event.title.includes('价格')
			})
		} else if (mode === MyCalendarMode.Stock) {
			return events?.filter(event => {
				return event.title.includes('库存') || event.title.includes('已售')
			})
		} else {
			return []
		}
	}

	return (
		<div
			className={ss.myCalendar}
			// onClick={onDismiss}
		>
			<div
				className={ss.fullCalendarBox}
				onClick={e => {
					e.stopPropagation()
				}}
			>
				<FullCalendar
					plugins={[dayGridPlugin, interactionPlugin]}
					initialView="dayGridMonth"
					locale={cnLocale}
					selectable={true}
					select={onSelect}
					dateClick={handleDayClick}
					eventClick={handleEventClick}
					events={filterEvents(events)}
					height="100%" // 设置高度为父容器的 100%
				/>
				<div className={ss.calendarFooter}>
					<Button onClick={onDismiss}>取消</Button>
					<Button
						type="primary"
						style={{ marginLeft: '20px' }}
						onClick={() => {
							message.success('保存成功')
							onDismiss()
						}}
					>
						保存
					</Button>
				</div>
			</div>
			{mode === MyCalendarMode.Price && (
				<Modal
					title="为选中的日期设置标准单价"
					open={showSetPriceModal}
					onOk={handlePriceOk}
					onCancel={handlePriceCancel}
					closable={false}
					width={316}
					zIndex={10000}
					wrapClassName={ss['set-price-modal']}
					centered
				>
					<div className={ss.priceRow}>
						<span className={ss['priceRow-name']}>场次1</span>
						<InputNumber
							className={ss['priceRow-input']}
							value={priceSetting.sessionOnePrice}
							min={0}
							precision={2}
							onChange={(value: any) => {
								setPriceSetting({ ...priceSetting, sessionOnePrice: value })
							}}
						/>
						<span className={ss['priceRow-unit']}>元/次</span>
					</div>
					<div className={ss.priceRow}>
						<span className={ss['priceRow-name']}>场次2</span>
						<InputNumber
							className={ss['priceRow-input']}
							value={priceSetting.sessionTwoPrice}
							min={0}
							precision={2}
							onChange={(value: any) => {
								setPriceSetting({ ...priceSetting, sessionTwoPrice: value })
							}}
						/>
						<span className={ss['priceRow-unit']}>元/次</span>
					</div>
					<div className={ss.priceRow}>
						<span className={ss['priceRow-name']}>场次3</span>
						<InputNumber
							className={ss['priceRow-input']}
							value={priceSetting.sessionThreePrice}
							min={0}
							precision={2}
							onChange={(value: any) => {
								setPriceSetting({ ...priceSetting, sessionThreePrice: value })
							}}
						/>
						<span className={ss['priceRow-unit']}>元/次</span>
					</div>
				</Modal>
			)}
			{mode === MyCalendarMode.RoomPrice && (
				<Modal
					title="为选中的日期设置标准单价"
					open={showSetRoomPriceModal}
					onOk={handleRoomPriceOk}
					onCancel={handleRoomPriceCancel}
					closable={false}
					width={316}
					zIndex={10000}
					wrapClassName={ss['set-price-modal']}
					centered
				>
					<div className={ss.priceRow}>
						<span className={ss['priceRow-name']}>价格</span>
						<InputNumber
							className={ss['priceRow-input']}
							value={roomPriceSetting.price}
							min={0}
							precision={2}
							onChange={(value: any) => {
								setRoomPriceSetting({ ...roomPriceSetting, price: value })
							}}
						/>
						<span className={ss['priceRow-unit']}>元/日</span>
					</div>
				</Modal>
			)}
			{mode === MyCalendarMode.Stock && (
				<Modal
					title="调整库存"
					open={showSetStockModal}
					onOk={handleStockOk}
					onCancel={handleStockCancel}
					closable={false}
					width={316}
					zIndex={10000}
					wrapClassName={ss['set-price-modal']}
					centered
				>
					<div className={ss.priceRow}>
						<span className={ss['priceRow-name']}>场次1</span>
						<InputNumber
							className={ss['priceRow-input']}
							value={stockSetting.sessionOneInventory}
							min={0}
							precision={0}
							onChange={(value: any) => {
								setStockSetting({ ...stockSetting, sessionOneInventory: value })
							}}
						/>
						<span className={ss['priceRow-unit']}>张</span>
					</div>
					<div className={ss.priceRow}>
						<span className={ss['priceRow-name']}>场次2</span>
						<InputNumber
							className={ss['priceRow-input']}
							value={stockSetting.sessionTwoInventory}
							min={0}
							precision={0}
							onChange={(value: any) => {
								setStockSetting({ ...stockSetting, sessionTwoInventory: value })
							}}
						/>
						<span className={ss['priceRow-unit']}>张</span>
					</div>
					<div className={ss.priceRow}>
						<span className={ss['priceRow-name']}>场次3</span>
						<InputNumber
							className={ss['priceRow-input']}
							value={stockSetting.sessionThreeInventory}
							min={0}
							precision={0}
							onChange={(value: any) => {
								setStockSetting({
									...stockSetting,
									sessionThreeInventory: value,
								})
							}}
						/>
						<span className={ss['priceRow-unit']}>张</span>
					</div>
				</Modal>
			)}
		</div>
	)
}

export default connect(
	({
		exhibitionManagement,
		roomManagement,
	}: {
		exhibitionManagement: ExhibitionManagementModelState
		roomManagement: RoomManagementModelState
	}) => ({
		exhibitionManagement,
		roomManagement,
	}),
)(MyCalendar)
